module.exports = __webpack_public_path__ + "img/portfolio-03.5dee8713.jpg";